import PercentInput from "./PercentInput";

export default PercentInput